export default "__VITE_ASSET__WLW7hxq5__"